import Vue from "vue";
import VueRouter from "vue-router";
import generalRouter from "@/modules/user/router";
import generalAdminRouter from "@/modules/admin/router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/modules/user/views/HomeView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/modules/user/views/LoginViwe.vue"),
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("@/modules/user/views/LoginViwe.vue"),
  },
  {
    path: "/users",
    ...generalRouter,
  },
  {
    path: "/admins",
    ...generalAdminRouter,
  },
  {
    path: "*",
    name: "PageNotFound",
    component: () => import("@/components/PageNotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
